import { ClassifierLibraryRowItemFragment } from '../../../api/client'
import Pagination from '../../../components/Pagination'
import ClassifierLibraryRow from './ClassifierLibraryRow'

const TH =
    'bg-ink-50 px-3 py-2.5 text-left text-[10.5px] font-semibold uppercase tracking-wide text-ink-500 border-b border-ink-200'

type Props = {
    items: ClassifierLibraryRowItemFragment[]
    offset: number
    limit: number
    total: number
    loading: boolean
    onPageChange: (offset: number, limit: number) => void
}

export default function ClassifierLibraryTable({
    items,
    offset,
    limit,
    total,
    loading,
    onPageChange
}: Props) {
    return (
        <div className="overflow-hidden rounded-lg border border-ink-200">
            <table className="w-full border-collapse bg-white text-sm">
                <thead>
                    <tr>
                        <th scope="col" className={TH}>
                            Classifier
                        </th>
                        <th scope="col" className={TH}>
                            Modality
                        </th>
                        <th scope="col" className={TH}>
                            Valence
                        </th>
                        <th scope="col" className={TH}>
                            Model
                        </th>
                        <th scope="col" className={TH}>
                            Coverage
                        </th>
                        <th scope="col" className={TH}>
                            Version
                        </th>
                        <th scope="col" className={TH}>
                            Updated
                        </th>
                    </tr>
                </thead>
                <tbody className="divide-y divide-ink-100">
                    {items.map((classifier) => (
                        <ClassifierLibraryRow key={classifier.id} classifier={classifier} />
                    ))}
                </tbody>
            </table>

            {/* Pagination footer — same control the content card list uses. It hides its
                page buttons when total <= limit, so the "single page" and "many pages"
                states are both handled here. */}
            <div className="border-t border-ink-200 px-3 py-2">
                <Pagination
                    offset={offset}
                    limit={limit}
                    total={total}
                    onChange={onPageChange}
                    loading={loading}
                />
            </div>
        </div>
    )
}
